export default "__VITE_ASSET__Cns5aNs8__"